/************
 Product Swiper
 ************/

// setup product swiper
let productImages = new Swiper("#productV2Swiper", {
    slidesPerView: "auto",
    pagination: {
        el: "#productV2SwiperPagination",
    }
});

// thumbnail
document.querySelectorAll(".productV2Thumbnail").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this);

        // change active slide
        productImages.slideTo(index);
    });
});

/*************
 Product Reviews
 **********/

// Scroll to reviews on review starts click
document.querySelector("#productV2Stars").addEventListener("click", function () {
    document.querySelector(".productV2-reviews-section").scrollIntoView();
})

/**************
 Product Options
 ***************/

// subscription toggle
document.querySelectorAll(".productSubscriptionV2Input").forEach(function (element) {
    element.addEventListener("change", updateProduct);
});

// option toggle
document.querySelectorAll(".productV2OptionInput").forEach(function (element) {
    element.addEventListener("change", function () {
        // manual override for the duradry-am variety pack, preselect the 3-pack
        if (product.handle === "duradry-am" && this.name === "Fragrance" && this.value === "Variety Pack") {
            document.querySelector(`.productV2OptionInput[name="Pack"][value="3-Pack"]`).checked = true;
        }

        updateProduct();
    });
});

// update active variant
function updateProduct() {
    // find active options
    let selectedOptions = [];
    document.querySelectorAll(".productV2OptionInput:checked").forEach(function (element) {
        selectedOptions.push(element.value);
    });

    // if selectedOptions is empty, set the default variant
    if (selectedOptions.length === 0) {
        activeVariant = product.variants[0];
    } else {
        // find the correct variant based on the active options
        activeVariant = null;
        for (let i = 0; i < product.variants.length; i++) {
            if (JSON.stringify(product.variants[i].options) == JSON.stringify(selectedOptions)) {
                activeVariant = product.variants[i];
                break;
            }
        }
    }

    // check for null variant
    if (activeVariant === null) {
        document.querySelector("#productV2ATC").disabled = true;
        document.querySelector("#productV2ATC").innerHTML = `Not Available`;
        return;
    }

    // update images if the variant has them
    if (activeVariant.featured_image && document.querySelector("#productV2ThumbnailVariant")) {
        document.querySelector("#productV2ThumbnailVariant").src = `${activeVariant.featured_image.src}&width=200`;
        document.querySelector("#productV2SwiperImageVariant").src = `${activeVariant.featured_image.src}&width=1000`;
    }

    // check for subscription
    const isSubscription = !!document.querySelector("#productSubscribeV2:checked");

    // update subscription info
    if (isSubscription) {
        // show subscription info (benefits)
        document.querySelector("#productV2SubscriptionInfo").classList.add("active")

        // get message for left bullet (normalyl comes from the pack description)
        let subscriptionInfo = document.querySelector(".productV2OptionsPacksItem:has(:checked) .productV2OptionsPacksItemInfoDescription.active")?.textContent || "Save 15% on every order";

        // override for 3-step-system
        if (product.handle === "3-step-system-90d") {
            subscriptionInfo = "Auto-delivers every 3 months";
        }

        // update subscription info
        document.querySelector("#productV2SubscriptionInfoCadence").textContent = subscriptionInfo;
    } else {
        document.querySelector("#productV2SubscriptionInfo")?.classList.remove("active")
    }

    // update descriptions
    document.querySelectorAll(".productV2OptionsPacksItemInfoDescription").forEach(element => element.classList.remove("active"));
    document.querySelectorAll(`.productV2OptionsPacksItemInfoDescription.${isSubscription ? "subscription" : "onetime"}`).forEach(element => element.classList.add("active"));

    // calculate real price, compare price and savings
    let realPrice, comparePrice, savings;
    if (isSubscription) {
        realPrice = activeVariant.price * 0.85;
    } else {
        realPrice = activeVariant.price;
    }

    // calculate compare at price savings
    comparePrice = activeVariant.compare_at_price || activeVariant.price;
    savings = Math.round((1 - (realPrice / comparePrice)) * 100);

    // update product price
    document.querySelector("#productV2Price span").textContent = price(realPrice);
    if (realPrice < comparePrice) {
        document.querySelector("#productV2Price s").textContent = price(comparePrice);
        document.querySelector("#productV2Price badge").textContent = `${savings}% OFF`;
    } else {
        document.querySelector("#productV2Price s").textContent = "";
        document.querySelector("#productV2Price badge").textContent = "";
    }

    // check if the variant is in stock
    if (activeVariant.available === true) {
        document.querySelector("#productV2ATC").disabled = false;
        document.querySelector("#productV2ATC").innerHTML = `Add To Cart - <span>${price(realPrice)}</span>`;
    } else {
        document.querySelector("#productV2ATC").disabled = true;
        document.querySelector("#productV2ATC").innerHTML = `Sold Out - <span>${price(realPrice)}</span>`;
    }

    // update pack pricing
    document.querySelectorAll(".productV2OptionsPacksItem").forEach(function (element) {
        // save the prices
        const unitPrice = parseFloat(element.dataset.unitPrice);
        const packPrice = parseFloat(element.dataset.packPrice);

        // save elements
        const unitPriceElement = element.querySelector(".productV2OptionsPacksItemPriceUnit");
        const packPriceElement = element.querySelector(".productV2OptionsPacksItemPriceTotal");

        // calculate purchase price
        if (isSubscription) {
            if (unitPriceElement) unitPriceElement.textContent = `$${Math.floor(unitPrice * 0.85)} ea.`;
            packPriceElement.textContent = price(packPrice * 0.85);
        } else {
            if (unitPriceElement) unitPriceElement.textContent = `$${Math.ceil(unitPrice)} ea.`;
            packPriceElement.textContent = price(packPrice);
        }
    });

    // update fragrance title and description (am-stick)
    const activeFragranceInput = document.querySelector(`#productV2OptionsFragrances .productV2OptionInput:checked`);
    if (activeFragranceInput) {
        document.querySelector("#productV2OptionsFragrancesTitle").innerHTML = `Fragrance: <b>${activeFragranceInput.value}</b>`;
        document.querySelector("#productV2OptionsFragrancesDesc").textContent = activeFragranceInput.dataset.description;
    }

    // update size title and description (duradry-wash)
    const activeSizeInput = document.querySelector(`#productV2OptionsSizes .productV2OptionInput:checked`);
    if (activeSizeInput) {
        document.querySelector("#productV2OptionsSizesTitle").innerHTML = `Size: <b>${activeSizeInput.value}</b>`;
    }

    // manual override of duradry-wash since the size selector has different pricing
    if (product.handle === "duradry-wash") {
        // if 2.5 FL
        if (document.querySelector(`.productV2OptionInput[name="Size"][value="2.5 FL. OZ."]:checked`)) {
            let unitPrices = [7.99, 8.33, 10];
            let realPrices = [4799, 2499, 1000];

            if (isSubscription) {
                document.querySelectorAll(".productV2OptionsPacksItemPriceUnit").forEach((element, index) => element.textContent = `$${Math.ceil(unitPrices[index] * 0.85)} ea.`);
                document.querySelectorAll(".productV2OptionsPacksItemPriceTotal").forEach((element, index) => element.textContent = price(realPrices[index] * 0.85));
            } else {
                document.querySelectorAll(".productV2OptionsPacksItemPriceUnit").forEach((element, index) => element.textContent = `$${Math.ceil(unitPrices[index])} ea.`);
                document.querySelectorAll(".productV2OptionsPacksItemPriceTotal").forEach((element, index) => element.textContent = price(realPrices[index]));
            }
        }
    }

}

// update product selection
updateProduct();

/****************
 * Product Quantity
 */

let quantity = 1;

/**************
 Product ATC
 ***************/

document.querySelector("#productV2ATC").addEventListener("click", async function () {
    // add loading animation
    this.classList.add("loading");


    // setup form data
    let formData = {
        items: []
    };

    // add main product
    formData.items.push({
        quantity: quantity,
        id: activeVariant.id,
    });

    // check for subscription
    const isSubscription = !!document.querySelector("#productSubscribeV2:checked");

    // add subscription if needed
    if (isSubscription) {
        formData.items[0].selling_plan = cadenceToPlan[variantToCadence[activeVariant.id]];
    }

    // add product
    await addProduct(formData);

    if (checkoutURL) {
        window.location.href = checkoutURL;
    } else {
        await openCart();
    }

    // remove loading animation
    setTimeout(() => {
        this.classList.remove("loading");
    }, 500);
});


/****************
 * Product FAQ
 */


//productFAQ event listeners for each of the questions
document.querySelectorAll(`.productV2FAQItemTitle`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});


// listen for subscription popup open
document.querySelectorAll('.productV2SubscriptionInfoItemTxtPopup')?.forEach(function (element) {
    element.addEventListener('click', function () {

        // open upgrade
        document.querySelector("#upgradeWrap").classList.remove("active");
        redirectCheckout = false; // disable redirect
        document.querySelector("body").classList.add("noScroll");
        document.querySelector("#upgrade").classList.add("active");
    });
});


/****************
 Returns Popup
 ****************/

document.querySelector("#productV2Returns").addEventListener("click", openReturnPopup);


/****************
 Product V2 Smooth Scrolling
 ****************/

document.querySelectorAll(`a[href="#product"]`).forEach(function (anchor) {
    anchor.addEventListener("click", function (e) {
        e.preventDefault();
        document.querySelector("#productV2").scrollIntoView({behavior: "smooth"});
    });
});
